<template><div><h1 id="vorlage-fur-mahnungen" tabindex="-1"><a class="header-anchor" href="#vorlage-fur-mahnungen"><span>Vorlage für Mahnungen</span></a></h1>
<p>Vorlage für Mahnungen — Definiert Vorlagen für Mahnungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Für die Mahnungen können damit Vorlagen definiert werden. Die Definition einer Vorlage basiert auf einem vorgängig bereits erfassten Mahnlauf. Der Mahnlauf kann bis auf die Aufbereitung erfasst und eingerichtet werden. Der Mahnlauf sollte wenn möglich nicht aufbereitet werden, damit zu einem späteren Zeitpunkt daran noch Änderungen vorgenommen werden können. Danach wird in der Vorlagentabelle die Jobnummer des entsprechenden Mahnlaufs eingetragen. Ab diesem Zeitpunkt werden künftige Mahnläufe anhand dieser Vorlage als Default vorgeschlagen. Die Vorschläge enthalten alle Werte der entsprechenden Vorlage.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Tabellen → Vorlagen für Mahnungen</p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobnummer</dt>
<dd>Jobnummer des Mahnlaufs die als Vorlage dient.</dd>
<dt>Beschreibung</dt>
<dd>Freie Beschreibung der Vorlage.</dd>
<dt>Offene Posten</dt>
<dd>Anzeige offene Posten</dd>
<dt>Auftragsart/Veranstaltungstyp</dt>
<dd>Anzeige des Auftragsart/Veranstaltungstyps.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.mahnprot.html" title="Mahnungen Protokoll">Mahnungen Protokoll</RouteLink></p>
</div></template>


